import { prependRoot } from "../util/prependRoot.js";
import { getApiRoot } from "../store/configureStore.js";
import axios from "axios";

const routePrefix = "/transactions/";

const TransactieApi = {
	setTransactieStatusToAangevraagd(transactionId) {
		const serviceUrl = prependRoot(`${routePrefix}settransactionstatetoaangevraagd/${transactionId}`, getApiRoot());
		return axios.put(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
	},
	getNewOrExistingTransactie(domain, domainId, requestorId, ignoreTransactionStatus) {
		const serviceUrl = prependRoot(`${routePrefix}newOrExisting/${domain}/${domainId}/${requestorId}/${ignoreTransactionStatus}`, getApiRoot());
		return axios.get(serviceUrl, {
			headers: { accept: "application/json" }
		});
	},
	cancelTransaction(transactionId) {
		const serviceUrl = prependRoot(routePrefix + 'cancelTransaction/' + transactionId, getApiRoot());
		return axios.put(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
	},
	getNewTransactie(domain, domainId) {
		const serviceUrl = prependRoot(`${routePrefix}new/${domain}/${domainId}`, getApiRoot());
		return axios.get(serviceUrl, {
			headers: { accept: "application/json" }
		});
	}
};

export default TransactieApi;